"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rules = void 0;
const profanity_1 = require("./profanity");
const isNotEmpty = (value) => {
    let error = null;
    if (!(value === null || value === void 0 ? void 0 : value.toString().trim().length)) {
        error = {
            rule: 'isNotEmpty',
            message: `Field cannot be empty`,
        };
    }
    return { value, error };
};
const isOfType = (value, type) => {
    let error = null;
    let valueToValidate = value;
    let isNaN = false;
    if (type === 'number') {
        valueToValidate = value / 1;
        isNaN = Number.isNaN(valueToValidate);
    }
    if (typeof valueToValidate !== type || isNaN) {
        error = {
            rule: 'isOfType',
            message: `Input value must be a ${type}`,
        };
    }
    return { value, error };
};
const isOfLength = (value, targetLength, options) => {
    let error = null;
    const { trim, message: customMessage } = options || {};
    if (trim && (value === null || value === void 0 ? void 0 : value.toString().trim().length) !== targetLength) {
        error = {
            rule: 'isOfLength',
            message: customMessage
                ? customMessage
                : `Input must be ${targetLength} characters long (excluding trailing whitespace)`,
        };
    }
    if (!trim && (value === null || value === void 0 ? void 0 : value.toString().length) !== targetLength) {
        error = {
            rule: 'isOfLength',
            message: customMessage
                ? customMessage
                : `Input must be ${targetLength} characters long`,
        };
    }
    return { value, error };
};
const isShorterOrEq = (value, targetLength, options) => {
    let error = null;
    const { trim, message: customMessage } = options || {};
    if (trim && (value === null || value === void 0 ? void 0 : value.toString().trim().length) > targetLength) {
        error = {
            rule: 'isShorterOrEq',
            message: customMessage
                ? customMessage
                : `Input cannot be more than ${targetLength} characters long (excluding trailing whitespace)`,
        };
    }
    if (!trim && (value === null || value === void 0 ? void 0 : value.toString().length) > targetLength) {
        error = {
            rule: 'isShorterOrEq',
            message: customMessage
                ? customMessage
                : `Input cannot be more than ${targetLength} characters long`,
        };
    }
    return { value, error };
};
const isLessThan = (value, target) => {
    let { error } = isOfType(value, 'number');
    if (typeof value === 'number' && value >= target) {
        error = {
            rule: 'isLessThan',
            message: `Input must be less than ${target}`,
        };
    }
    return { value, error };
};
const isLessOrEq = (value, target) => {
    let { error } = isOfType(value, 'number');
    if (parseFloat(value) > target) {
        error = {
            rule: 'isLessOrEq',
            message: `Input must be less than or equal to ${target}`,
        };
    }
    return { value, error };
};
const isGreaterThan = (value, target) => {
    let { error } = isOfType(value, 'number');
    if (parseFloat(value) <= target) {
        error = {
            rule: 'isGreaterThan',
            message: `Input must be greater than ${target}`,
        };
    }
    return { value, error };
};
const isGreaterOrEq = (value, target) => {
    let { error } = isOfType(value, 'number');
    if (parseFloat(value) < target) {
        error = {
            rule: 'isGreaterOrEq',
            message: `Input must be greater than or equal to ${target}`,
        };
    }
    return { value, error };
};
const isEqual = (value, target) => {
    let error = null;
    if (parseFloat(value) !== target) {
        error = {
            rule: 'isEqual',
            message: `Input value must be equal to ${target}`,
        };
    }
    return { value, error };
};
const isMatching = (value, target, entity = 'Input values') => {
    let error = null;
    if (value !== target) {
        error = {
            rule: 'isMatching',
            message: `${entity} must match`,
        };
    }
    return { value, error };
};
const isEmail = (value) => {
    var _a;
    let error = null;
    const trimmedValue = (_a = value === null || value === void 0 ? void 0 : value.toString().trim()) !== null && _a !== void 0 ? _a : '';
    const emailRegex = /^(?![.\s])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // Check for valid email structure and disallow consecutive dots anywhere in the email.
    if (!emailRegex.test(trimmedValue) || /(\.\.)/.test(trimmedValue)) {
        error = {
            rule: 'isEmail',
            message: `Please enter a valid email address`,
        };
    }
    return { value: trimmedValue, error };
};
const isAlpha = (value) => {
    let error = null;
    if (!/^[A-Za-z\s]+$/.test(value.toString().trim())) {
        error = {
            rule: 'isAlpha',
            message: `Please enter alpha characters only`,
        };
    }
    return { value, error };
};
const isAlphaCaps = (value) => {
    let error = null;
    if (!/^[A-Z]+$/.test(value.toString().trim())) {
        error = {
            rule: 'isAlpha',
            message: `Please enter alpha  Caps characters only`,
        };
    }
    return { value, error };
};
const isAlphaWithException = (value, exceptionChars) => {
    let error = null;
    const rule = new RegExp(`^[A-Za-z${exceptionChars}]+$`);
    if (!rule.test(value.toString().trim())) {
        error = {
            rule: 'isAlphaWithException',
            message: `Please enter alpha and/or ${exceptionChars} characters only`,
        };
    }
    return { value, error };
};
const isAlphaNumericWithException = (value, exceptionChars) => {
    let error = null;
    const rule = new RegExp(`^[A-Za-z0-9${exceptionChars}]+$`);
    if (!rule.test(value === null || value === void 0 ? void 0 : value.toString().trim())) {
        error = {
            rule: 'isAlphaNumericWithException',
            message: `Please enter alphanumeric and/or ${exceptionChars} characters only`,
        };
    }
    return { value, error };
};
const isAplhaNumeric = (value) => {
    let error = null;
    if (!/^\w+$/.test(value.toString())) {
        error = {
            rule: 'isAplhaNumeric',
            message: `Value must include alphanumeric characters only`,
        };
    }
    return { value, error };
};
const isAlphaNumericWithSpace = (value) => {
    let error = null;
    const rule = new RegExp('^[a-zA-Z0-9\\s]+$');
    if (!rule.test(value.toString().trim())) {
        error = {
            rule: 'isAlphaNumericWithSpace',
            message: `Please enter alphanumeric with space characters only`,
        };
    }
    return { value, error };
};
const dateFormats = {
    'MM/YYYY': /^\d{1,2}\/\d{4}$/,
    'MM/DD/YYYY': /^\d{1,2}\/\d{1,2}\/\d{4}$/,
};
const isDate = (value, format = 'MM/DD/YYYY') => {
    let error = null;
    // First check for the pattern
    const stringValue = value instanceof Date
        ? value.toLocaleDateString('en-US')
        : value.toString();
    if (!dateFormats[format].test(stringValue)) {
        error = {
            rule: 'isDate',
            message: 'Incorrect date format',
        };
    }
    // Parse the date parts to integers
    const parts = stringValue.split('/');
    let day = 0;
    if (format === 'MM/DD/YYYY') {
        day = parseInt(parts[1], 10);
    }
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);
    const incorrectYearRange = year < 1000 || year > 3000;
    const incorrectMonthRange = month == 0 || month > 12;
    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;
    let incorrectDateRange;
    if (format === 'MM/DD/YYYY') {
        incorrectDateRange = day <= 0 || day > monthLength[month - 1];
    }
    if (incorrectYearRange ||
        incorrectMonthRange ||
        (format === 'MM/DD/YYYY' && incorrectDateRange)) {
        error = {
            rule: 'isDate',
            message: 'Incorrect range',
        };
    }
    return { value, error };
};
const isOfAgeOrOlder = (value, target) => {
    const now = new Date();
    const dateToValidate = value instanceof Date
        ? value
        : new Date(((value === null || value === void 0 ? void 0 : value.length) === 10 ? value : `01/${value}`));
    let isYounger = false;
    if (dateToValidate.getFullYear() + target > now.getFullYear()) {
        isYounger = true;
    }
    else if (dateToValidate.getFullYear() + target === now.getFullYear()) {
        if (dateToValidate.getMonth() - now.getMonth() > 0) {
            isYounger = true;
        }
        else if (dateToValidate.getMonth() - now.getMonth() === 0 &&
            dateToValidate.getDate() - now.getDate() > 0) {
            isYounger = true;
        }
    }
    const error = isYounger
        ? {
            rule: 'isOfAgeOrOlder',
            message: `You must be ${target} to proceed`,
        }
        : null;
    return { value, error };
};
const isOfAgeOrYounger = (value, target) => {
    const now = new Date();
    const dateToValidate = value instanceof Date
        ? value
        : new Date(((value === null || value === void 0 ? void 0 : value.length) === 10 ? value : `01/${value}`));
    let isOlder = false;
    if (dateToValidate.getFullYear() + target < now.getFullYear()) {
        isOlder = true;
    }
    else if (dateToValidate.getFullYear() + target === now.getFullYear()) {
        if (dateToValidate.getMonth() - now.getMonth() < 0) {
            isOlder = true;
        }
        else if (dateToValidate.getDate() - now.getDate() < 0) {
            isOlder = true;
        }
    }
    const error = isOlder
        ? {
            rule: 'isOfAgeOrYounger',
            message: `Please enter a valid date of birth`,
        }
        : null;
    return { value, error };
};
const isInRange = (value, min, max, options) => {
    const { inclusive } = options || {};
    let error = null;
    if (inclusive && value < min && value > max) {
        error = {
            rule: 'isInRange',
            message: `Input value must be in ${min} to ${max} inclusive range`,
        };
    }
    else if (!inclusive && value <= min && value >= max) {
        error = {
            rule: 'isInRange',
            message: `Input value must be in ${min} to ${max} exclusive range`,
        };
    }
    return { value, error };
};
const isFreeOfForbiddenCharacters = (value, regex) => {
    let error = null;
    if (!regex.test(value === null || value === void 0 ? void 0 : value.toString())) {
        error = {
            rule: 'isFreeOfForbiddenCharacters',
            message: 'Input contains forbidden characters',
        };
    }
    return { value, error };
};
const isMatchingOneOf = (value, targetValues) => {
    let error = null;
    if (!targetValues.find((tValue) => tValue === value)) {
        error = {
            rule: 'isMatchingOneOf',
            message: 'Input value does not match one of the required options',
        };
    }
    return { value, error };
};
const isNotMatchingOneOf = (value, targetValues) => {
    let error = null;
    if (targetValues.find((tValue) => tValue === value)) {
        error = {
            rule: 'isNotMatchingOneOf',
            message: 'Input value must not match one of the required options',
        };
    }
    return { value, error };
};
const isDateInRange = (value, targetValueStart, targetValueEnd, optionalParams) => {
    let error = null;
    const startDate = new Date(targetValueStart).getTime();
    const endDate = (targetValueEnd ? new Date(targetValueEnd) : new Date()).getTime();
    const validatedDate = new Date(value).getTime();
    if (endDate < validatedDate || startDate > validatedDate) {
        error = {
            rule: 'isDateInRange',
            message: 'Provided date is not in range',
        };
    }
    return { value, error };
};
const isMatchingPattern = (value, pattern) => {
    const rule = new RegExp(pattern);
    let error = null;
    if (rule && !rule.test(value)) {
        error = {
            rule: 'isMatchingPattern',
            message: 'Input does not match provided pattern',
        };
    }
    return { value, error };
};
const isTrue = (value) => {
    let error = null;
    if (!value) {
        error = {
            rule: 'isTrue',
            message: 'Input does not match provided pattern',
        };
    }
    return { value, error };
};
const hasIntersection = (value, targetValues) => {
    const intersection = value.filter((element) => targetValues.includes(element));
    let error = null;
    if (!intersection) {
        error = {
            rule: 'hasIntersection',
            message: 'Provided array does not intersect with target',
        };
    }
    return { value, error };
};
const isNotProfanity = (value) => {
    let error = null;
    const tokenized_values = value === null || value === void 0 ? void 0 : value.toString().split(' ');
    const profanityWordFound = tokenized_values.some((tokenized_value) => {
        return profanity_1.profanity.includes(tokenized_value.toLowerCase());
    });
    if (profanityWordFound) {
        error = {
            rule: 'isNotProfanity',
            message: 'Profanity found in the text entered.',
        };
    }
    return { value, error };
};
const allValuesMustMatch = (value, targetValues) => {
    let error = null;
    if (!value.every((element) => targetValues.includes(element))) {
        error = {
            rule: 'allValuesMustMatch',
            message: "One or more inputs doesn't match the list of allowed values",
        };
    }
    return { value, error };
};
const isNotEmptyList = (value) => {
    let error = null;
    if (!(value === null || value === void 0 ? void 0 : value.length) || (value === null || value === void 0 ? void 0 : value.length) === 0) {
        error = {
            rule: 'isNotEmptyList',
            message: 'List cannot be empty',
        };
    }
    return { value, error };
};
exports.rules = {
    isNotEmpty,
    isOfLength,
    isOfType,
    isEqual,
    isTrue,
    isGreaterThan,
    isLessThan,
    isMatching,
    isEmail,
    isAlpha,
    isDate,
    isOfAgeOrOlder,
    isInRange,
    isShorterOrEq,
    isOfAgeOrYounger,
    isFreeOfForbiddenCharacters,
    isAplhaNumeric,
    isAlphaCaps,
    isMatchingOneOf,
    isNotMatchingOneOf,
    isDateInRange,
    isLessOrEq,
    isGreaterOrEq,
    isAlphaWithException,
    isAlphaNumericWithException,
    isAlphaNumericWithSpace,
    isMatchingPattern,
    hasIntersection,
    isNotProfanity,
    allValuesMustMatch,
    isNotEmptyList,
};
